var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAyudantias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 412.1 89.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.7,32.1l1.5-1.5c1.1,1.5,2.6,2.5,4.5,2.5s3.7-1.2,3.7-3.2-2-2.9-4.1-3.8c-2.3-1-4.8-2.1-4.8-5.2s2.3-4.8,5.1-4.8,4.1,1.1,5.3,2.5l-1.3,1.3c-1.4-1.5-2.6-1.9-4-1.9s-3.1,1-3.1,2.8,1.7,2.8,3.6,3.5c2.5,1,5.3,1.9,5.3,5.5s-2.6,5.1-5.6,5.1-4.9-1.3-6.2-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.2,19.8c0-.8.6-1.3,1.3-1.3s1.3.6,1.3,1.3-.6,1.3-1.3,1.3-1.3-.6-1.3-1.3ZM264.6,23.2h2v11.5h-2v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.5,33.5l1.1-1.6c.8.7,2,1.3,3.3,1.3s2.2-.6,2.2-1.7-1.2-1.5-2.5-1.8c-1.7-.5-3.7-1-3.7-3.2s1.9-3.4,4.1-3.4,2.7.4,3.7,1.1l-1.1,1.5c-1-.7-1.9-.9-2.7-.9-1.3,0-2.1.5-2.1,1.4s1.4,1.4,2.9,1.8c1.6.4,3.3,1.1,3.3,3.3s-1.7,3.6-4.2,3.6-3.3-.8-4.3-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.2,25.1h-2.4v9.7h-2v-9.7h-2.4v-1.8h2.4v-4.1h2v4.1h2.4v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.2,29.3h-10.1c.1,2.2,1.9,3.9,4.1,3.9s2.7-.7,3.5-1.9l1.7.7c-1,1.9-2.9,3.1-5.2,3.1-3.4,0-6-2.7-6-6s2.6-6,6-6,6,2.5,6,5.8v.4ZM289.4,27.6h7.7c-.5-1.6-2-2.8-3.8-2.8s-3.4,1.1-3.9,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.5,27.4v7.3h-2v-7.3c0-1.4-1-2.5-2.3-2.5s-2.4,1.1-2.4,2.5v7.3h-2v-7.3c0-1.4-1-2.5-2.4-2.5s-2.4,1.1-2.4,2.5v7.3h-2v-11.5h2v1c.7-.8,1.6-1.3,2.6-1.3s2.4.7,3.1,1.7c.8-1,2-1.7,3.4-1.7,2.4,0,4.3,2,4.3,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.1,23.2v11.5h-2v-1.6c-1,1.1-2.4,1.8-4.2,1.8-3.1,0-5.7-2.7-5.7-6s2.7-6,5.7-6,3.3.7,4.2,1.8v-1.6h2ZM330.1,29c0-2.2-1.8-4-4-4s-4,1.8-4,4,1.8,4,4,4,4-1.8,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.2,16.4v18.3h-2v-1.6c-1,1.1-2.4,1.8-4.2,1.8-3.1,0-5.7-2.7-5.7-6s2.7-6,5.7-6,3.3.7,4.2,1.8v-8.5h2ZM351.2,29c0-2.2-1.8-4-4-4s-4,1.8-4,4,1.8,4,4,4,4-1.8,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.1,29.3h-10.1c.1,2.2,1.9,3.9,4.1,3.9s2.7-.7,3.5-1.9l1.7.7c-1,1.9-2.9,3.1-5.2,3.1-3.4,0-6-2.7-6-6s2.6-6,6-6,6,2.5,6,5.8v.4ZM358.2,27.6h7.7c-.5-1.6-2-2.8-3.8-2.8s-3.4,1.1-3.9,2.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.9,60.7h-9.7l-1.2,3.6h-4.9l8.8-23.1h4.3l8.9,23.1h-5l-1.2-3.6ZM263.6,56.9l-3.5-10.3-3.5,10.3h7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.4,49.8l-8.7,21.7h-4.4l2.9-7.2h-1l-5.9-14.5h4.8l3.9,11.1,4-11.1h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.1,58.8v-9h4.3v8.6c0,1.6,1,2.5,2.3,2.5s2.3-.8,2.3-2.5v-8.6h4.3v9c0,3.6-2.4,5.8-6.7,5.8s-6.6-2.3-6.6-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322,41.2v23.1h-4l-.2-2c-1,1.3-2.5,2.3-4.8,2.3-3.8,0-7-3.2-7-7.6s3.2-7.6,7-7.6,3.6.8,4.6,2v-10.3h4.4ZM317.9,57c0-2.1-1.7-3.8-3.7-3.8s-3.7,1.7-3.7,3.8,1.6,3.8,3.7,3.8,3.7-1.7,3.7-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.9,49.8v14.5h-4l-.2-2c-1,1.3-2.5,2.3-4.8,2.3-3.8,0-7-3.2-7-7.6s3.2-7.6,7-7.6,3.6.8,4.6,2v-1.7h4.4ZM336.9,57c0-2.1-1.7-3.8-3.7-3.8s-3.7,1.7-3.7,3.8,1.6,3.8,3.7,3.8,3.7-1.7,3.7-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.8,55v9.3h-4.3v-8.7c0-1.4-1-2.3-2.4-2.3s-2.5,1-2.5,2.5v8.6h-4.4v-14.5h4.4v1.5c1.1-1.2,2.5-1.7,4.1-1.7,2.9,0,5.2,2.4,5.2,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.8,53.2h-2.7v11.1h-4.4v-11.1h-2.7v-3.4h2.7v-5.2h4.4v5.2h2.7v3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.4,49.8h4.4v14.5h-4.4v-14.5ZM373.7,46.5l4.7-5,2.1,2.3-5.2,4.4-1.6-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.7,49.8v14.5h-4l-.2-2c-1,1.3-2.5,2.3-4.8,2.3-3.8,0-7-3.2-7-7.6s3.2-7.6,7-7.6,3.6.8,4.6,2v-1.7h4.4ZM392.6,57c0-2.1-1.7-3.8-3.7-3.8s-3.7,1.7-3.7,3.8,1.6,3.8,3.7,3.8,3.7-1.7,3.7-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.6,62.7l1.8-2.9c1.2.8,3.1,1.5,4.5,1.5s2-.5,2-1.3-1.5-1.2-3.4-1.8c-2.1-.6-4.4-1.5-4.4-4.3s2.8-4.5,6.1-4.5,4,.6,5.5,1.5l-1.8,2.6c-1.1-.7-2.8-1.2-4-1.2s-1.7.4-1.7,1.1c0,1.1,1.6,1.3,3.4,1.8,2.7.7,4.6,1.7,4.6,4.4s-2.4,4.9-6.1,4.9-5-1-6.4-1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.8,24.3c-11.3,0-20.5,9.2-20.5,20.5s9.2,20.5,20.5,20.5,20.5-9.2,20.5-20.5-9.2-20.5-20.5-20.5ZM166.8,57.5c-7,0-12.6-5.7-12.6-12.6s5.7-12.6,12.6-12.6,12.6,5.7,12.6,12.6-5.7,12.6-12.6,12.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.7,24.4c-11.3,0-20.4,9.1-20.5,20.3h0v45.2h8.2s-.1-28.8,0-28.7c3.4,2.6,7.7,4.1,12.3,4.1,11.3,0,20.5-9.2,20.5-20.5s-9.2-20.5-20.5-20.5ZM117.7,57.5c-7,0-12.6-5.7-12.6-12.6s5.7-12.6,12.6-12.6,12.6,5.7,12.6,12.6-5.7,12.6-12.6,12.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.6 53.5 27.6 53.5 27.6 53.5 27.6 53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.5,57.3h0c-7.2,0-13-5.8-13-13V0h-8v44.3h0c0,11.6,9.4,21,21,21h0s0,0,0,0h0c.3,0-2.6,0,3.5,0v-8h-3.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83,30.5c-5.4-5.4-13.1-7.1-20-5.2-.5.2-6,1.9-9,5.2l-24.5,22.8c-1.4,1.3-2.6,2.5-4.4,3.2-1.8.8-3.7,1.1-5.6,1-2.9-.2-5.8-1.4-8-3.6-1.7-1.7-2.9-3.7-3.4-5.9h18.1l12.6-11.8c-1.2-2.2-3.1-5-4-5.8-8-8-21-8-28.9,0-8,8-8,21,0,28.9,5.4,5.4,13.1,7.1,20,5.2,3.2-.9,6.4-2.5,9-5l25.9-24.1c5-4.3,11.9-4.3,16.6.4,4.9,4.9,5,12.9,0,17.9-3.5,3.5-8.6,4.6-13.1,3v8.1c6.5,1.3,13.6-.6,18.6-5.6,8-8,8-21,0-28.9ZM11.6,35.9c2.3-2.3,5.4-3.6,8.9-3.6h0c3.6,0,6.8,1.6,9.1,4l-5,4.6H8.5c.6-1.9,1.7-3.6,3.1-5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.1,6.5c0,3.5-2.7,6.2-6.3,6.2s-6.4-2.7-6.4-6.2,2.8-6.2,6.4-6.2,6.3,2.7,6.3,6.2ZM222,6.5c0,2.7,2,4.9,4.8,4.9s4.7-2.2,4.7-4.9-2-5-4.7-5-4.8,2.2-4.8,4.9ZM225.8,9.7h-1.4V3.6c.6-.1,1.4-.2,2.4-.2s1.7.2,2.1.5c.3.3.6.8.6,1.4s-.5,1.2-1.3,1.4h0c.6.3.9.8,1.1,1.6.2.9.3,1.3.5,1.5h-1.5c-.2-.2-.3-.8-.5-1.5-.1-.7-.5-1-1.3-1h-.7v2.5ZM225.9,6.2h.7c.8,0,1.4-.3,1.4-.9s-.4-.9-1.3-.9-.6,0-.8,0v1.8Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyudantias);
export default __webpack_public_path__ + "static/media/ayudantias.6bfdde6018c9c4e8198816e473277020.svg";
export { ForwardRef as ReactComponent };